import { useInactivityTimeout } from '@/hooks/useInactivityTimeout';

/**
 * Component that monitors user inactivity and logs out after 5 minutes
 * Only active on web when "Remember Me" is NOT checked
 */
export const InactivityMonitor: React.FC = () => {
  useInactivityTimeout();
  return null; // This component doesn't render anything
};
